import Component from '../abstracts/Component';
// quick refactoring of privacyComponent
export default class NewPrivacyKoreaComponent extends Component {

  static get SELECTORS() {
    return {
      Form: ".js-validate-form",
      inputMailDomain: ".js-kr-select-validation",
      selectMailDomain: ".js-kr-select",
      wrapperMailDomain: ".js-kr-select-wrapper",
    };
  }

  static get CLASSES() {
    return {
      AVOID_KR_PRIVACY_HANDLER: 'avoid-kr-privacy-handler',
    };
  }

  // KR -------------------------

  krFormInputValidation() {
    const numRegex = new RegExp("^[a-zA-Z\u3131-\uD79D\\s]+$");
    const inputName = document.querySelectorAll('.js-kr-validation');
    let errSpan = '';

    inputName.forEach(input => {
      $(inputName).on('blur.input', (e) => {
        const inputVal = e.currentTarget.value;
        const clientErrorBox = e.currentTarget.nextSibling;
        if (numRegex.test(inputVal) && inputVal !== '') {
          e.currentTarget.classList.remove('error');
          clientErrorBox.classList.add('d-none');
        } else {
          e.currentTarget.classList.add('error');
          clientErrorBox.classList.remove('d-none');
          return false;
        }
      })
    });
  }

  //validation for emailDomain on KR registerForm
  krFormSelectInputValidation() {
    const numRegex = new RegExp("^[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"),
          inputName = document.querySelector(NewPrivacyKoreaComponent.SELECTORS.inputMailDomain),
          selectName = document.querySelector(NewPrivacyKoreaComponent.SELECTORS.selectMailDomain),
          wrapperName = document.querySelector(NewPrivacyKoreaComponent.SELECTORS.wrapperMailDomain);

    $(selectName).on('change', (e) => {
      const value = e.currentTarget.value;
      if(value === "input"){
        wrapperName.classList.add("d-none");
        inputName.type = "text";
        inputName.value = "";
        inputName.focus();
      }else{
        inputName.value = value;
      }
    });

    $(inputName).focusout((e) => {
      let inputVal = e.currentTarget.value;
      if (inputVal != null) {
        inputVal = inputVal.trim();
      }
      const clientErrorBox = e.currentTarget.nextSibling;
      if (numRegex.test(inputVal) && inputVal !== '') {
        e.currentTarget.classList.remove('error');
        clientErrorBox.classList.add('d-none');
      } else {
        e.currentTarget.classList.add('error');
        clientErrorBox.classList.remove('d-none');
        return false;
      }
    })

  }

  handleSubmitOnFormValidationError() {
    $('form').on('submit.sbmt', function(e) {
      const inputs = $(this).find('input');
      const validation = $(inputs).data('validation');
      if($(inputs).hasClass('error') && validation !== undefined && validation != '' && validation !== '') {
        e.preventDefault();
      }
    })
  }


  onSelectAllKr() {
      let allChk = false;
      let krCheckout = (document.body.classList.contains('t-checkout') && document.body.dataset.website === 'kr');
      let krRegister = (document.body.classList.contains('t-register') && document.body.dataset.website === 'kr');
      $('body').on('change.krall','.js-kr-privacySelectAll', function (e) {
        e.stopImmediatePropagation();
        const $form = $(e.currentTarget).closest('form');
        const $container = $(e.currentTarget).closest('form').find('.js-privacy-kr')
        const $kr = $('.js-kr-selectable');
        if (!allChk) {
          $container.find('input[type="checkbox"]').prop('checked', true);
          $kr.removeClass('is-disabled');
          $form.find('.js-privacy-opts').removeClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", false);
          // $form.find('button[type="submit"]').attr("disabled", false);
          $container.find('input[type="radio"][value=yes]').prop('checked', true);
          if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
            $form.find('button[type="submit"]').attr("disabled", false);
          }
          if(krCheckout) {
            $form.find('.js-button-submit').removeClass("disabled");
          }
          if (krRegister) {
            let registerForm = document.querySelector('form.register');
            // disable submit button
            let submitButton = registerForm.querySelector('.js-register-form-check');
            if (submitButton != null) {
              submitButton.classList.remove('disabled');
              submitButton.disabled = false;
            }
          }
          allChk = true;
        } else {
          $container.find('input[type="checkbox"]').prop('checked', false);
          $container.find('input[type="radio"][value=yes]').prop('checked', false);
          $kr.addClass('is-disabled');
          $form.find('.js-privacy-opts').addClass('is-disabled');
          $container.find('input[type="radio"]').attr("disabled", true);
          if(krCheckout) {
            $form.find('.js-button-submit').addClass("disabled");
          }
          if (krRegister) {
            let registerForm = document.querySelector('form.register');
            // disable submit button
            let submitButton = registerForm.querySelector('.js-register-form-check');
            if (submitButton != null) {
              submitButton.classList.add('disabled');
              submitButton.disabled = true;
            }
          }
          allChk = false;
        }
      })
      $('body').on('change.kradioPrivacy', '[name="newsletterProfiling"], [name="newsletter"]', function (e) {
        e.stopImmediatePropagation();
        const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
        const $form = $(e.currentTarget).closest('form');
        if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }
      });
    }


  aknwloedgeKrPrivacy() {
    let ctx = this;
    let krCheckout = (document.body.classList.contains('t-checkout') && document.body.dataset.website === 'kr')
    let isKr = (document.body.dataset.website === 'kr');


      $('body').on('change.krreq', 'input[type="checkbox"]', function(e) {
        if(e.target.classList.contains(NewPrivacyKoreaComponent.CLASSES.AVOID_KR_PRIVACY_HANDLER)){
          // Avoid stop propagation for all the element with this class
          return;
        }

        e.stopImmediatePropagation();
        let closestForm = $(e.currentTarget).closest('form');
        let button = '';
        let type = '';
        let requiredElements = closestForm.find('input.kr-mandatory');
        let isRequired = [];
        let chkRequired = [];


        for (let item of requiredElements) {
          isRequired.push(item);

          if($(item).is(':checked')) {
            chkRequired.push(item);
          }
        }

        switch(krCheckout) {
          case true:
            button = '.js-button-submit';
            type = 'fakeBtn';
            break;
          case false:
            button = 'button[type="submit"]';
            type = 'btn';
            break;
          default:
        }


        if( chkRequired.sort().toString() == isRequired.sort().toString()) {
          $('.js-privacy-kr').find('input[type="radio"]').attr("disabled", false);
          closestForm.find('.js-privacy-opts').removeClass('is-disabled');
          let submitBtn = closestForm.find(button);
          if(type === 'btn' ) {
            submitBtn.attr("disabled", false);
          } else {
            submitBtn.removeClass("disabled");
          }
          // registration page
          if (submitBtn.hasClass('js-register-form-check')) {
            submitBtn.removeClass("disabled");
          }
        } else {
          $('.js-privacy-kr').find('input[type="radio"]').attr("disabled", true);
          closestForm.find('.js-privacy-opts').addClass('is-disabled');
          isRequired == [];
          let submitBtn = closestForm.find(button);
          if(type === 'btn' ) {
            submitBtn.attr("disabled", true);
          } else {
            submitBtn.addClass("disabled");
          }
          // registration page
          if (submitBtn.hasClass('js-register-form-check')) {
            submitBtn.addClass("disabled");
          }
        }
      })

    // reset array
    $('body').on('change').on('change.reqall', '.js-kr-privacySelectAll', function(e) {
      chkRequired = [];
    })
  }

  animateOnSubmit(){
    this.$on('submit', ({event}) => {
      const button = $('#registerForm [type=submit]');
      this.$emit(this.$customEvents.LOADER_EVENTS.showLocal, {
        button: button,
        loadertype: button.data('loaderLocal')
      });

    }, '.js-validate-form')
  }

  // al render della pagina setto checked = false, l'utente cosi deve riaccettare la privacy
  disableKrPrivacy () {
    let krCheckout = (document.body.classList.contains('t-checkout') && document.body.dataset.website === 'kr');
    const form = document.getElementsByClassName('js-kr-policy-container');
    const $container = $(form).find('.js-privacy-kr');
    const $kr = $('.js-kr-selectable');
    $('.js-kr-privacySelectAll').prop('checked', false);
    $container.find('input[type="checkbox"]').prop('checked', false);
    $container.find('input[type="radio"][value=yes]').prop('checked', false);
    $kr.addClass('is-disabled');
    $(form).find('.js-privacy-opts').addClass('is-disabled');
    $container.find('input[type="radio"]').attr("disabled", true);
    if(krCheckout) {
      $(form).find('.js-button-submit').addClass("disabled");
    }
    // i do either for registration page
    let krRegister = (document.body.classList.contains('t-register') && document.body.dataset.website === 'kr');
    if (krRegister) {
      let registerForm = document.querySelector('form.register');
      // all privacy selectors
      let registerPrivacyInputs = registerForm.querySelectorAll('.js-kr-selectable input');
      if (registerPrivacyInputs != null) {
        registerPrivacyInputs.forEach(input => {
          input.checked = false;
        });
      }
      // privacy opts
      let registerPrivacyOpts = registerForm.querySelector('.js-privacy-opts');
      if (registerPrivacyOpts != null) {
        registerPrivacyOpts.classList.add('is-disabled');
        let registerPrivacyOptsInputs = registerPrivacyOpts.querySelectorAll('input');
        if (registerPrivacyOptsInputs != null) {
          registerPrivacyOptsInputs.forEach(input => {
            input.checked = false;
          });
        }

      }
      // disable submit button
      let submitButton = registerForm.querySelector('.js-register-form-check');
      if (submitButton != null) {
        submitButton.disabled = true;
      }
    }
  }

  customKREmail() {
    // i do either for registration page
    let krRegister = (document.body.classList.contains('t-register') && document.body.dataset.website === 'kr');
    if (krRegister) {
      let registerForm = document.querySelector('form.register');
      if (registerForm != null) {
        // let's searche the input
        let emailDomain = registerForm.querySelector('input[name=emailDomain]')
        if (emailDomain != null) {
          // search the select
          let emailDomainSelect = registerForm.querySelector('.js-kr-email-select');
          if (emailDomainSelect != null && emailDomain.value != '') {
            // it there is the select and the value is different from void
            const options = Array.from(emailDomainSelect.options);
            const optionToSelect = options.find(item => item.text === emailDomain.value);
            // i search from the select if the value is undefine
            if (typeof optionToSelect == 'undefined') {
              // if  there is no match it means it's custom
              const wrapperName = document.querySelector(NewPrivacyKoreaComponent.SELECTORS.wrapperMailDomain),
                    inputName = document.querySelector(NewPrivacyKoreaComponent.SELECTORS.inputMailDomain);
              // so i hide the select, show the input and yuou should see the custom email domain
              if (wrapperName != null && inputName != null) {
                wrapperName.classList.add("d-none");
                inputName.type = "text";
                inputName.focus();
              }
            }
          }
        }
      }
    }
  }

  render() {
    const isKr = document.querySelector('.js-kr-policy-container');
    super.render();

    if (isKr) {
      this.krFormInputValidation();
      this.krFormSelectInputValidation();
      this.onSelectAllKr();
      this.aknwloedgeKrPrivacy();
      this.handleSubmitOnFormValidationError();
      this.animateOnSubmit();
      this.disableKrPrivacy();
      this.customKREmail();
    }
  }

}
